import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { MissedDoseReportPage } from '@/features/incidents/medication-report/missed-dose-report-page'

/**
 * Report a missed dose as an incident, on its own page (Phase 2 Task 6, MI-8). The incident
 * wizard's own steps in medication mode; the API decides who may report, and the page shows
 * the supervisor handoff when the answer is no.
 */
export const Route = createFileRoute(
  '/_authenticated/_organization/medication-followups/$occurrenceId/report'
)({
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: MissedDoseReportPage,
})
